
<template>
  <el-form
    label-width="150px"
    :model="fM"
    ref="sFormRef"
  >
    <el-row>
      <el-col
        :key="index"
        v-for="item, index in fS"
        :span="7"
        :offset="2"
      >
        <el-form-item
          :label="item.label"
          :prop="item.prop"
        >
          <component
            :is="item.component"
            :type="item.type"
            :placeholder="item.placeholder"
            :filterable="item.filterable"
            :remote="item.remote"
            :remote-method="item.remoteMethod"
            :loading="item.loading"
            style="width:100%;min-width:230px"
            v-model="fM[item.prop]"
            clearable
          >
            <template v-if="item.component==='el-select'">
              <el-option
                v-for="optionItem, optionIndex in item.options"
                :key="optionIndex"
                :label="optionItem.label"
                :value="optionItem.value"
              />
            </template>
          </component>
        </el-form-item>
      </el-col>
      <el-col
        :span="4"
        :offset="bOffset()"
      >
        <el-button
          @click="resetEmit"
        >
          {{ t(resetButton) }}
        </el-button>
        <el-button
          type="primary"
          @click="submitEmit"
        >
          {{ t(submitButton) }}
        </el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    formModel: {
      type: Object,
      default: () => {
        return null
      }
    },
    formStruct: {
      type: Array,
      default: () => []
    },
    formRules: {
      type: Object,
      default: () => {
        return null
      }
    },
    submitButton: {
      type: String,
      required: false,
      default: 'common.submit'
    },
    resetButton: {
      type: String,
      required: false,
      default: 'common.reset'
    }
  },
  emits: ['submit', 'reset'],
  setup(props, context) {
    const { t } = useI18n()
    const sFormRef = ref()
    const fM = ref(props.formModel)
    const fS = ref(props.formStruct)
    const bOffset = () => {
      if ((props.formStruct.length % 2) === 0) {
        return 2
      }
      return 11
    }
    const submitEmit = () => {
      context.emit('submit')
    }
    const resetEmit = () => {
      sFormRef.value.resetFields()
      context.emit('reset')
    }
    return {
      t,
      fM,
      fS,
      sFormRef,
      bOffset,
      submitEmit,
      resetEmit
    }
  }
})
</script>
